import { GetServerSideProps } from "next";
import Layout from "../../components/Layout";
import { tentangPerusahaanMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import {
  defBreadcrumb,
  tentangPerusahaanBreadcrumb
} from "../../data/DataBreadcrumb";
import AboutHCID from "../../components/About/AboutHCID";
import Vision from "../../components/About/Vision";
import AboutAchievement from "../../components/About/AboutAchievement";
import CardSliderComponent from "../../components/UserInterface/CardSliderComponent";
import AboutProfile from "../../components/About/AboutProfile";
import AboutTataKelola from "../../components/About/AboutTataKelola";
import AboutLicense from "../../components/About/AboutLicense";
import downloadIcon from "../../../public/static/images/svg/download-icon.svg";
import { useEffect } from "react";
import { GACustomEvent } from "src/utils/analytics";
import { getSiaranPers } from "src/utils/magnolia";

const TentangPerusahaan = (props) => {
  const { breadcrumb, title, description, path, dataPers } = props;
  useEffect(() => {
    GACustomEvent("about_us_web_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={tentangPerusahaanBreadcrumb} />
      <AboutHCID />
      <Vision />
      <AboutProfile />
      <CardSliderComponent
        headingText="Siaran Pers"
        data={dataPers}
        href="/tentang-perusahaan/siaran-pers"
        as="/tentang-perusahaan/siaran-pers"
      />
      <AboutAchievement />
      <AboutTataKelola
        title="Tata Kelola Perusahaan Yang Baik"
        description={`Home Credit Indonesia mengembangkan struktur dan sistem Tata Kelola Perusahaan Yang Baik (Good Corporate Governance atau "GCG") dengan memperhatikan prinsip-prinsip GCG sesuai dengan ketentuan dalam Peraturan OJK Nomor 30/POJK.05/2014  tentang Tata Kelola Perusahaan Yang Baik Bagi Perusahaan Pembiayaan`}
        downloadIcon={downloadIcon}
      />
      <AboutLicense title="Lisensi" />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  const { title, description, path } = tentangPerusahaanMeta;

  const {data, status} = await getSiaranPers({
    params: {
      limit: 3,
    },
  })

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + path,
        name: title
      }
    }
  ];
  if (status == 200) {
    return {
      props: {
        breadcrumb,
        title,
        description,
        path,
        dataPers: data.results
      }
    };
  } else {
    res.writeHead(301, {
      Location: "/halaman-tidak-ditemukan?q=tentang-perusahaan"
    });
    res.end();
  }
};

export default TentangPerusahaan;
